import { queryOptions, useQuery } from '@tanstack/react-query';

import type { ParticipantBookingDto } from '@/api/core-api/types.gen';

import { participantBookingControllerGetBooking } from '@/api/core-api';
import { getClient } from '@/utils/get-api-client';

import { queryKeys } from './query-keys';

export async function fetchParticipantBooking({
  projectId,
  userId,
}: {
  projectId: string;
  userId: string;
}): Promise<ParticipantBookingDto> {
  const response = await participantBookingControllerGetBooking({
    client: getClient(userId),
    path: { projectId },
  });

  if (!response.data) {
    throw new Error('Failed to load booking');
  }

  return response.data;
}

/**
 * The participant's booking state on a project: the calendar, the current
 * slot, and the gates the schedule, reschedule and cancel pages decide on.
 */
export const participantBookingQueryOptions = (
  projectId: string,
  userId: string,
) =>
  queryOptions({
    queryKey: queryKeys.booking.byProject(projectId, userId),
    queryFn: () => fetchParticipantBooking({ projectId, userId }),
    staleTime: 0,
  });

export function useParticipantBooking(projectId: string, userId: string) {
  return useQuery(participantBookingQueryOptions(projectId, userId));
}
